/// 权限id
export function isAuth(id) {
    let auth = JSON.parse(localStorage.getItem('japanUserAuth'))
    let flag = auth.findIndex(item => item.id == id)
    return flag == -1 ? false : true
}

 //拷贝
 export function copy(value) {
  let oInput = document.createElement("textarea"); //创建一个隐藏input（重要！）
  oInput.value = value; //赋值
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象
  document.execCommand("Copy"); // 执行浏览器复制命令
  oInput.className = "oInput";
  oInput.style.display = "none";
  this.$message.success("复制成功")
}